const MAX_RANGE_DAYS = 90;

function utcMidnight(date: Date): Date {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}

export function buildBoundedDateRange(start?: Date, end: Date = new Date()): Date[] {
  const final = utcMidnight(end);
  const requestedInitial = start ? utcMidnight(start) : undefined;

  if (requestedInitial && requestedInitial.getTime() > final.getTime()) {
    return [];
  }

  const earliestAllowed = new Date(final);
  earliestAllowed.setUTCDate(final.getUTCDate() - (MAX_RANGE_DAYS - 1));

  const initial = requestedInitial && requestedInitial.getTime() > earliestAllowed.getTime()
    ? requestedInitial
    : earliestAllowed;

  const result: Date[] = [];
  const current = new Date(initial);
  while (current.getTime() <= final.getTime()) {
    result.push(new Date(current));
    current.setUTCDate(current.getUTCDate() + 1);
  }

  return result;
}
